import React, { FC } from 'react';
import { DocumentsColumnsName } from 'src/common/DocumentsLibrary/types';
import { DocumentsLibrary } from 'src/common/DocumentsLibrary';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const hideColumn = [DocumentsColumnsName.attach] as const;

interface IProps {}

export const DocumentsLibraryPage: FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.title}>{t('Navigation.documentLibrary')}</div>
      <DocumentsLibrary hideFields={hideColumn} files={[]} />
    </>
  );
};

export default DocumentsLibraryPage;
